import './products.css';
import React from 'react';
import ProductCard from '../cards/productCards.js';
import UVCImage from '../assets/products/UV-C.png';
import UV_RECH_LIGHT_Image from '../assets/products/rechargable-uv-led-torch-light.jpg';

export default function Products() {
    const productsList = [
        {
          name: "UV-C LED",
          price: "𝟤̶𝟥̶𝟢̶ 129",
          description: "Introducing the Germicidal LED, a groundbreaking solution for targeted and efficient disinfection. Harnessing the power of ultraviolet-C (UVC) light-emitting diodes (LEDs), this compact and energy-efficient technology disrupts the DNA or RNA of microorganisms, offering a highly effective germicidal solution. Designed with strategic fixtures to ensure optimal coverage, the Germicidal LED is versatile for various applications. With low maintenance requirements, an environmentally responsible design, and user-friendly operation, this LED technology represents a new era in reliable and sustainable germicidal solutions. Experience enhanced disinfection capabilities while minimizing energy consumption and environmental impact with Germicidal LED.",
          specification: 'Voltage: 5V - 6V, Power: 5mW ~ 10mW, Current: 60mA, Wave Length: 270nM ~ 280nM, Focal Coverage: 120°',
          imageUrl: UVCImage,
          link: 'https://forms.gle/8TvETRAFEYUX1ekH8',
          alt: 'UV-C LED'
        },
        {
            name: "Rechargeable UV Torch Light - with Emergency Light",
            price: "𝟩̶𝟧̶𝟢̶ 449",
            description: "It can identify fake & real currency notes. It can be used for investigations to reveal things that are not visible to naked eyes. It can be used as Normal Flash Light. Available in 3 Colors Blue, Yellow and Black",
            specification: `LED Voltage: 3.5V, UV LED Wave Length: 365nM ~ 372.5nM, mini USB-B port. Consists of 1 UV LED and 10 Normal Visible Light LEDs with Rechargable inBuild 500mA Battery and USB 2.0 cable. Single Press the button for UV Light and Long Press for Flash Light. Use normal 5V Mobile Charger for charging the torch light`,
            imageUrl: UV_RECH_LIGHT_Image,
            link: 'https://forms.gle/8TvETRAFEYUX1ekH8',
            alt: 'Rechargeable UV Torch Light - with Emergency Light'
        },
    ]
    return (
      <div>
        <div className="Product">
          <body className="Product-body">

            {
                productsList && productsList.map( product => {
                    return (
                        <div className="Product-card">
                            <ProductCard
                            name = { product.name }
                            price = { product.price }
                            description = { product.description } 
                            specification = { product.specification } 
                            imageUrl = { product.imageUrl } 
                            link = { product.link } 
                            alt = { product.alt } />
                        </div>
                    )
                })
            }

            <div className="Product-trademarks">
              <p> &copy; Copyright 2024 &nbsp; All rights reserved</p>
              <p> Developed by Danyson &nbsp; </p>
            </div>
          </body>
        </div>
      </div>
    );
}
